import React, {PropsWithChildren} from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {MinimumGamblingAgeBox} from "./boxes/minimum-gambling-age.box";
import {MinimumGamblingAgeIconBox} from "./boxes/icon/minimum-gambling-age-icon.box";
import classNames from 'classnames';
import {CyClass} from "../../../../common/cy-classes";
import {BlankHorizontalSeparatorBox} from "../../../basic-components/blank-separator/blank-horizontal-separator.box";

interface MinimumGamblingAgeComponentProps extends PropsWithChildren {
    className?: string;
    iconBox?: React.ComponentType;
    isShownInHeader?: boolean;
}

export const MinimumGamblingAgeComponent = observer(
    class MinimumGamblingAgeComponent extends OrbitComponent<MinimumGamblingAgeComponentProps> {

        private _onClickHandler = async () => {
            this.services.analytics.sendOrbitUserFlowEvent("Navigation","Header", 'Icon_responsible_gaming_click');
            await this.services.linksNavigation.openResponsibleGaming();
        }

        private _getIconType(): string {
            return this.services.configuration.data.header.responsibleIcons?.ageButton?.iconType;
        }

        private _getIcon(): string {
            const age = this.services.regulation.current.responsibleGamingAge;
            switch (this._getIconType()) {
                case 'wide':
                    return this.services.theme.currentTheme.images.regulationSpecific.denmark.age18PlusWide.toString();
                case 'flat':
                    if(age === 21) {
                        return this.services.theme.currentTheme.images.responsibleGambling.age21PlusFlat.toString();
                    } else {
                        return this.services.theme.currentTheme.images.responsibleGambling.age18PlusFlat.toString();
                    }
                case 'capsule':
                    return this.services.theme.currentTheme.images.responsibleGambling.age18PlusCapsule.toString();
                default:
                    if(age === 21) {
                        return this.services.theme.currentTheme.images.responsibleGambling.age21PlusRound.toString();
                    } else {
                        return this.services.theme.currentTheme.images.responsibleGambling.age18PlusRound.toString();
                    }
            }
        }

        render() {
            const url = this._getIcon();
            const IconBox = this.props.iconBox ?? MinimumGamblingAgeIconBox;
            const isShownInHeader = this.props.isShownInHeader ?? false;
            return (
                <MinimumGamblingAgeBox onClick={this._onClickHandler}
                                       isShownInHeader={isShownInHeader}
                                       className={classNames(this.props.className, CyClass('cy-open-responsible-gaming-button'))}>
                    <IconBox src={url} isShownInHeader={isShownInHeader} isWide={this._getIconType() === "wide"}/>
                    {this.props.children}
                    <BlankHorizontalSeparatorBox multiplier={isShownInHeader ? 0.5 : 1}/>
                </MinimumGamblingAgeBox>
        );
        }
    }
);